module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_0.b9509e38.png";